import { CampaignDashboardController } from './campaign-dashboard.controller'

/* @ngInject */
function campaignDashboard () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-dashboard/campaign-dashboard.html?$$REVISION$$',
    controller: CampaignDashboardController
  }
}

export { campaignDashboard }
